// components/Tables/AttendanceTable.js
import React from 'react';

const AttendanceTable = ({ data = [], onViewDetails }) => {
  return (
    <div className="table-responsive">
      <table className="table table-history mb-0">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Статус</th>
            <th>Години</th>
            <th>Дії</th>
          </tr>
        </thead>
        <tbody>
          {data.map((attend, index) => (
            <tr key={index}>
              <td>{new Date(attend.date).toLocaleDateString('uk-UA')}</td>
              <td>{attend.status}</td>
              <td>{attend.hours}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => onViewDetails(attend)}
                >
                  Деталі
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceTable;